module.exports = __webpack_public_path__ + "e85b1a56c5e870ae3dae394d14fe39e6.svg";